<template>
  <section :class="claseSection">
    <div class="flex flex-col w-full max-w-[76rem] px-4 md:px-20 bg-gris">
      <!-- Título de la sección -->
      <div class="text-center pb-4 md:pb-6">
        <h3 class="text-1xl md:text-2xl font-semibold text-gray-900 tracking-wide">
          {{ texto_header }}
        </h3>
      </div>

      <!-- Version Desktop: Carrusel -->
      <div class="hidden md:flex justify-center">
        <Carrusel 
          :data="marcasData" 
          :itemsPorPagina="itemsPorPaginaDesk"
          :ClaseSlide="ClaseSlideDesk" 
          :autoplay="true" 
          :autoplayInterval="4000" 
          :bucle="true"
          
          :habilitarBotonesNav="true" 
          customBotonesNavClass="p-1 md:p-2 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
          customIconClass="text-current w-5 h-5" 
          customPrevPosition="left-0 -translate-x-[1rem]"
          customNextPosition="right-0 translate-x-[1rem]" 
        
          :motrarPuntos="false">
          
          <!-- Slot para renderizar CardTipo1 en desktop -->
          <template #contenido="{ items }">
            <CardTipo1 v-for="(item, index) in items" :key="index" 
            :clase_contenedor_padre="item.clase_contenedor_padre" 
            :imagen_clase="item.imagen_clase"
            :imagen="item.imagen" 
            :paso="item.paso" 
            :titulo="item.titulo" 
            :texto="item.texto" />
          </template>
        </Carrusel>
      </div>

      <!-- Versión Mobile: Carrusel -->
      <div class="block md:hidden h-[7rem]">
        <Carrusel 
          :data="marcasData" 
          :itemsPorPagina="itemsPorPaginaMob"
          :ClaseSlide="ClaseSlideMob" 
          :autoplay="false" 
          :autoplayInterval="4000" 
          :bucle="true"

          :habilitarBotonesNav="true" 
          customBotonesNavClass="p-2 bg-white hover:bg-gray-100 text-gray-800 border border-gray-300 shadow-md"
          customIconClass="text-current w-5 h-5" 
          customPrevPosition="left-0 -translate-x-3"
          customNextPosition="right-0 translate-x-3" 
        
          :motrarPuntos="false">
          
          <!-- Slot para renderizar CardTipo1 en mobile -->
          <template #contenido="{ items }">
            <CardTipo1 v-for="(item, index) in items" :key="index" 
            :clase_contenedor_padre="item.clase_contenedor_padre" 
            :imagen_clase="item.imagen_clase"
            :imagen="item.imagen" 
            :paso="item.paso" 
            :titulo="item.titulo" 
            :texto="item.texto" />
          </template>
        </Carrusel>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import Carrusel from '~/components/Carruseles/Carrusel.vue'
import CardTipo1 from '~/components/Cards/CardTipo1.vue'
import { NEGOCIOS } from "~/constants/negocios"

const modo_sistema = useState('modo_sistema');

// Computed property que retorna los items por página en desktop según el modo_sistema
const itemsPorPaginaDesk = computed(() => {
  switch (modo_sistema.value) {
    case NEGOCIOS.FRENOS:
      return 4
    case NEGOCIOS.ACEITES:
      return 3
    case NEGOCIOS.HOME:
      return 6
    default:
      return 6
  }
})

// Computed property que retorna los items por página en mobile según el modo_sistema
const itemsPorPaginaMob = computed(() => {
  switch (modo_sistema.value) {
    case NEGOCIOS.FRENOS:
      return 1
    case NEGOCIOS.ACEITES:
      return 1
    case NEGOCIOS.HOME:
      return 2
    default:
      return 1
  }
})

const texto_header = computed(() => {
  switch (modo_sistema.value) {
    case NEGOCIOS.ACEITES:
      return 'Nuestras marcas'
    case NEGOCIOS.HOME:
      return 'Nuestras marcas recomendadas'
    default:
      return 'Nuestras marcas'
  }
})

const claseSection = computed(() => {
  switch (modo_sistema.value) {
    case NEGOCIOS.ACEITES:
      return 'pt-4 pb-4 md:pt-6 md:pb-6 flex flex-col items-center w-full'
    case NEGOCIOS.FRENOS:
      return 'pt-4 pb-4 md:pt-6 md:pb-6 flex flex-col items-center bg-GRIS_CLARO w-full'
    case NEGOCIOS.HOME:
      return 'pt-4 pb-4 md:pt-6 md:pb-6 flex flex-col items-center bg-GRIS_CLARO w-full'
    default:
      return 'pt-4 pb-4 md:pt-6 md:pb-6 flex flex-col items-center w-full'
  }
})

const ClaseSlideDesk = computed(() => {
  switch (modo_sistema.value) {
    case NEGOCIOS.FRENOS:
      return 'grid grid-cols-4 gap-5 h-full p-2'
    case NEGOCIOS.ACEITES:
      return 'grid grid-cols-3 gap-5 h-full p-2'
    case NEGOCIOS.HOME:
      return 'grid grid-cols-6 gap-5 h-full p-2'
    default:
      return 'grid grid-cols-6 gap-5 h-full p-2'
  }
})

const ClaseSlideMob = computed(() => {
  switch (modo_sistema.value) {
    case NEGOCIOS.FRENOS:
      return 'flex flex-col gap-5 h-full p-2 w-full'
    case NEGOCIOS.ACEITES:
      return 'flex flex-col gap-5 h-full p-2 w-full'
    case NEGOCIOS.HOME:
      return 'grid grid-cols-2 gap-5 h-full p-2 w-full' 
    default:
      return 'flex flex-col gap-5 h-full p-2 w-full'
  }
})

const logos_neumaticos = ['BFGOODRICH', 'BRIDGESTONE', 'CONTINENTAL_V1', 'FIRESTONE', 'HANKOOK', 'INTERSTATE', 'MICHELLIN_V1', 'PIRELLI_V1', 'TRACMAX'];
const logos_aceites = ['ACDELCO', 'CASTROL', 'CHAMPION', 'MOBIL', 'SHELLHELIX', 'TOTALENERGIES'];
const logos_baterias = ['ACDELCO', 'DELKOR', 'FULLSTARK'];
const logos_frenos = ['ACDELCO', 'TEXTAR', 'PENFLEX', 'SANGSIN'];
const logos_home = ['BFGOODRICH', 'BRIDGESTONE', 'CONTINENTAL_V1', 'FIRESTONE', 'HANKOOK', 'INTERSTATE', 'MICHELLIN_V1', 'PIRELLI_V1', 'TRACMAX', 'ACDELCO', 'CASTROL', 'CHAMPION', 'MOBIL', 'SHELLHELIX', 'TOTALENERGIES', 'DELKOR', 'FULLSTARK'];

// Computed property que genera dinámicamente el array de marcas
const marcasData = computed(() => {
  let logos = logos_home
  let carpeta = 'home'
  
  switch (modo_sistema.value) {
    case NEGOCIOS.NEUMATICOS:
      logos = logos_neumaticos
      carpeta = 'neumaticos'
      break
    case NEGOCIOS.ACEITES:
      logos = logos_aceites
      carpeta = 'ACEITES'
      break
    case NEGOCIOS.FRENOS:
      logos = logos_frenos
      carpeta = 'frenos'
      break
    case NEGOCIOS.HOME:
      logos = logos_home
      carpeta = 'home'
      break
    case NEGOCIOS.BATERIAS:
      logos = logos_baterias
      carpeta = 'baterias'
      break
    default:
      logos = logos_home
      carpeta = 'home'
  }
  
  return logos.map(logo => ({
    clase_contenedor_padre: 'py-8 md:py-7 px-6 md:px-5 h-full md:h-auto',
    imagen_clase: 'flex h-full w-auto md:h-auto md:w-full',
    imagen: `/img/${carpeta}/svg_logos_marcas/${logo}.svg`,
    paso: '',
    titulo: '',
    texto: ''
  }))
})
</script>